import { useState } from "react";
import { resolveUrl } from "../../lib/media";
import { frameStyle, imgFilter, frameBlockClass } from "../../lib/frame";

// Renders any image with an optional manual frame (zoom + position) and optional
// subtle legibility effects (brightness). The PARENT element must clip overflow
// (rounded/overflow-hidden) — every place we use this already does.
// Default frame = centered cover (unchanged).
//
// Options de bloc (par média, stockées dans frame) :
//   - frame.format === "original" → le conteneur épouse les proportions intrinsèques de l'image
//     (détectées au chargement) au lieu d'un rectangle fixe.
//   - frame.fit === "contain" → proportions conservées, jamais recadrée/déformée.
//   - frame.noBg / frame.border / frame.maxW → fond, bordure et largeur max du bloc.
export const FramedImage = ({ src, frame, effects, alt = "", className = "", loading = "lazy", defaultFit = "cover", testid }) => {
  const f = frame || {};
  const intrinsic = f.format === "original";
  const [ratio, setRatio] = useState(null); // largeur / hauteur intrinsèque
  const style = frameStyle(frame, defaultFit);
  const filter = imgFilter(effects);
  if (filter) style.filter = filter;

  if (intrinsic) {
    // Bloc auto-ajusté : l'image s'affiche à ses proportions réelles (jamais recadrée).
    return (
      <div className={frameBlockClass(f)} style={ratio ? { aspectRatio: String(ratio) } : undefined} data-testid={testid ? `${testid}-block` : undefined}>
        <img src={resolveUrl(src)} alt={alt} loading={loading} draggable={false} data-testid={testid}
          onLoad={(e) => { const el = e.currentTarget; if (el.naturalWidth && el.naturalHeight) setRatio(el.naturalWidth / el.naturalHeight); }}
          className={`w-full h-full object-contain ${className}`}
          style={{ objectPosition: style.objectPosition, transform: style.transform, transformOrigin: style.transformOrigin, ...(filter ? { filter } : {}) }} />
      </div>
    );
  }

  const needsWrap = f.noBg || f.border || (f.maxW && f.maxW !== "full");
  const img = (
    <img
      src={resolveUrl(src)}
      alt={alt}
      loading={loading}
      draggable={false}
      data-testid={testid}
      className={`w-full h-full ${className}`}
      style={style}
    />
  );
  if (!needsWrap) return img;
  return <div className={frameBlockClass(f)} data-testid={testid ? `${testid}-block` : undefined}>{img}</div>;
};
